<footer class="as-home-footer as-font-white">
  @if (onMobile) {
    <div class="as-row as-justify-center">
      <mat-icon class="as-logo as-mt-20" svgIcon="ic-alsuper-white"></mat-icon>
    </div>
  }
  <div class="as-row as-align-center as-justify-sb as-account">
    @if (!token) {
      <div class="as-register as-row as-align-center">
        <a routerLink="autenticacion/registro">
          <button mat-stroked-button>{{ 'FOOTER.register' | translate }}</button>
        </a>
        <div class="as-row as-align-center">
          <p class="as-font as-font-normal as-font-14 as-font-white">
            {{ 'FOOTER.alreadyAccount' | translate }}
          </p>
          <a
            routerLink="autenticacion/iniciar-sesion"
            class="as-font-underline as-font-green as-pointer"
            >
            {{ 'FOOTER.login' | translate }}
          </a>
        </div>
      </div>
    }
    <div class="as-download-app">
      <a class="as-font-14 as-font-bold">
        {{ 'FOOTER.downloadApp' | translate }}
      </a>
      <div class="as-row as-align-center">
        <a [href]="appStoreUrl" target="_blank">
          <img
            class="as-pointer as-app-store"
            width="150"
            height="48"
            ngSrc="assets/images/app-store.png"
            />
        </a>
        <a [href]="googlePlayUrl" target="_blank">
          <img
            width="150"
            height="48"
            class="as-pointer as-google-play"
            ngSrc="assets/images/google-play.png"
            />
        </a>
      </div>
    </div>
  </div>
  @if (!onMobile) {
    <div class="as-footer-main-content">
      <div class="as-footer-lists">
        <!-- ALSUPER -->
        <div class="as-column as-justify-sb as-list-footer">
          <a class="as-font-14 as-font-bold">
            {{ 'GENERAL.alsuper' | translate }}
          </a>
          @for (item of alsuperList; track item) {
            <a
              [routerLink]="item.route"
              class="as-font-14 as-pointer as-font-white"
              (click)="onNavigate(item.route)"
              >
              {{ item.label | translate }}
            </a>
          }
        </div>
        <!-- ALSUPER -->
        <!-- ALIADOS COMERCIALES -->
        <div class="as-column as-justify-sb as-list-allies">
          <a class="as-font-14 as-font-bold">
            {{ 'FOOTER.allies' | translate }}
          </a>
          @for (item of alliesList; track item) {
            <div>
              @if (item.route !== '') {
                <a
                  class="as-font-14 as-pointer as-font-white"
                  [href]="item.route"
                  target="_blank"
                  >
                  {{ item.label | translate }}
                </a>
              } @else {
                <mat-label
                  (click)="openCEDISModal()"
                  class="as-font-14 as-pointer as-font-white"
                  >
                  {{ item.label | translate }}
                </mat-label>
              }
            </div>
          }
        </div>
        <!-- ALIADOS COMERCIALES -->
        <!-- VIVE TU SUPER -->
        <div class="as-column as-justify-sb as-list-life">
          <a class="as-font-14 as-font-bold">
            {{ 'FOOTER.liveYourSuper' | translate }}
          </a>
          @for (item of liveList; track item) {
            <a
              [routerLink]="item.route"
              class="as-font-14 as-pointer as-font-white"
              (click)="onNavigate(item.route)"
              >
              {{ item.label | translate }}
            </a>
          }
        </div>
        <!-- VIVE TU SUPER -->
        <!-- AYUDA -->
        <div class="as-help-list">
          <a class="as-font-14 as-font-bold">
            {{ 'GENERAL.help' | translate }}
          </a>
          @for (item of helpList; track item) {
            <a
              [routerLink]="item.route"
              class="as-font-14 as-pointer as-font-white"
              (click)="onNavigate(item.route)"
              >
              {{ item.label | translate }}
            </a>
          }
        </div>
        <!-- AYUDA -->
        <!-- ÚNETE AL EQUIPO -->
        <div class="as-column as-justify-sb as-join-list">
          <a class="as-font-14 as-font-bold">
            {{ 'FOOTER.joinUs' | translate }}
          </a>
          @for (item of joinList; track item) {
            <div>
              <a
                class="as-font-14 as-pointer as-font-white"
                [href]="item.route"
                target="_blank"
                >
                {{ item.label | translate }}
              </a>
            </div>
          }
        </div>
        <!-- ÚNETE AL EQUIPO -->
      </div>
      <div>
        <a class="as-font-14 as-font-bold">
          {{ 'GENERAL.followUs' | translate }}
        </a>
        <div class="as-social-media-container">
          <a
            href="https://api.whatsapp.com/send?phone=526141318323"
            target="_blank"
            >
            <mat-icon svgIcon="ic-wa-white"></mat-icon>
          </a>
          <a href="https://www.instagram.com/alsuperoficial" target="_blank">
            <mat-icon svgIcon="ic-ig-white"></mat-icon>
          </a>
          <a href="https://www.facebook.com/AlsuperOficial" target="_blank">
            <mat-icon svgIcon="ic-fb-white"></mat-icon>
          </a>
          <a
            href="https://www.youtube.com/channel/UCfR_zu3Iun-X9it_nA4LWNw"
            target="_blank"
            >
            <mat-icon svgIcon="ic-yt-white"></mat-icon>
          </a>
        </div>
        <p class="as-font-14 as-font-bold as-mt-20">
          {{ 'GENERAL.paymentsForms' | translate }}
        </p>
        <div class="as-payments">
          <mat-icon svgIcon="ic-visa-white"></mat-icon>
          <mat-icon svgIcon="ic-mastercard-footer"></mat-icon>
          <mat-icon svgIcon="ic-amex-blue"></mat-icon>
        </div>
      </div>
    </div>
  } @else {
    <mat-accordion>
      @for (item of footerListMobile; track item) {
        <mat-expansion-panel
          (opened)="item.open = true"
          (closed)="item.open = false"
          hideToggle="true"
          >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-label class="as-font as-font-14 as-font-bold as-font-white">
                {{ item.header | translate }}
              </mat-label>
            </mat-panel-title>
            <mat-panel-description>
              @if (!item.open) {
                <mat-icon svgIcon="ic-plus-white"></mat-icon>
              }
              @if (item.open) {
                <mat-icon
                  svgIcon="ic-minus"
                  color="white"
                ></mat-icon>
              }
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="as-column">
            @for (item of item.list; track item) {
              <a
                [routerLink]="item.route"
                class="as-font-14 as-pointer as-font-white"
            (click)="
              item.route !== '' ? onNavigate(item.route) : openCEDISModal()
            "
                >
                {{ item.label | translate }}
                <br />
                <br />
              </a>
            }
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
    <div class="as-footer-main-content">
      <a class="as-font-14 as-font-bold">
        {{ 'GENERAL.followUs' | translate }}
      </a>
      <div class="as-social-media-container">
        <a
          href="https://api.whatsapp.com/send?phone=526141318323"
          target="_blank"
          >
          <mat-icon svgIcon="ic-wa-white"></mat-icon>
        </a>
        <a href="https://www.instagram.com/alsuperoficial" target="_blank">
          <mat-icon svgIcon="ic-ig-white"></mat-icon>
        </a>
        <a href="https://www.facebook.com/AlsuperOficial" target="_blank">
          <mat-icon svgIcon="ic-fb-white"></mat-icon>
        </a>
        <a
          href="https://www.youtube.com/channel/UCfR_zu3Iun-X9it_nA4LWNw"
          target="_blank"
          >
          <mat-icon svgIcon="ic-yt-white"></mat-icon>
        </a>
      </div>
      <p class="as-font-14 as-font-bold as-mt-20">
        {{ 'GENERAL.paymentsForms' | translate }}
      </p>
      <div class="as-payments">
        <mat-icon svgIcon="ic-visa-white"></mat-icon>
        <mat-icon svgIcon="ic-mastercard-footer"></mat-icon>
        <mat-icon svgIcon="ic-amex-blue"></mat-icon>
      </div>
    </div>
  }
  @if (!onMobile) {
    <mat-divider color="accent"></mat-divider>
  }
  @if (!onMobile) {
    <div class="as-last-line">
      <mat-icon class="as-logo" svgIcon="ic-alsuper-white"></mat-icon>
      <mat-label>
        {{ 'FOOTER.copy' | translate }} {{ year }}
        {{ 'FOOTER.copyright' | translate }}
      </mat-label>
      <a routerLink="/nosotros/terminos"
        ><p
        (click)="onNavigate('/nosotros/terminos')"
        class="as-font as-font-12 as-font-white"
        >
        {{ 'FOOTER.terms' | translate }}
      </p></a
      >
      <a routerLink="/nosotros/privacidad"
        ><p
        (click)="onNavigate('/nosotros/privacidad')"
        class="as-font as-font-12 as-font-white"
        >
        {{ 'FOOTER.privacy' | translate }}
      </p></a
      >
      <mat-label>
        {{ 'FOOTER.byBambuMobile' | translate }} {{ version }}
      </mat-label>
    </div>
  } @else {
    <div class="as-last-line">
      <mat-label>
        {{ 'FOOTER.copy' | translate }} {{ year }}
        {{ 'FOOTER.copyright' | translate }} </mat-label
        ><br />
        <a routerLink="/nosotros/terminos"
          ><p
          (click)="onNavigate('/nosotros/terminos')"
          class="as-font as-font-12 as-font-white as-font-underline"
          >
          {{ 'FOOTER.terms' | translate }}
        </p></a
        >
        <br />
        <a routerLink="/nosotros/privacidad"
          ><p
          (click)="onNavigate('/nosotros/privacidad')"
          class="as-font as-font-12 as-font-white as-font-underline"
          >
          {{ 'FOOTER.privacy' | translate }}
        </p></a
        >
        <br />
        <mat-label>
          {{ 'FOOTER.byBambuMobile' | translate }} {{ version }}
        </mat-label>
      </div>
    }
  </footer>
